<template>
  <section class="millennium-kiln mx-auto relative clearfix w w-full">
    <div class="text-center">
      <div class="text-center content-title">
        <span class="inline-block line-css"></span>
        <span class="font-css">
          <span>时光里的御窑</span> IMPERIAL KILN IN HISTORY
        </span>
        <span class="inline-block line-css"></span>
      </div>
      <!-- <div><img src="../../../static/images/home/times.png" alt="" /></div> -->
      <Collapse></Collapse>
      <div class="s-lists flex">
        <div class="w-1/3 time-content history">
          <ListBar
            name="历史概况"
            data="history"
            :pageSize="5"
            :type="1"
          ></ListBar>
        </div>
        <div class="w-1/3 time-content famous">
          <ListBar
            name="名人典故"
            data="famous"
            :pageSize="5"
            :type="1"
          ></ListBar>
        </div>
        <div class="w-1/3 time-content documents">
          <ListBar
            name="资料文献"
            data="documents"
            :pageSize="5"
            :type="1"
          ></ListBar>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ListBar from '@/components/home/HomeList'
import Collapse from '@/components/home/Collapse'

export default {
  name: 'millennium-kiln',
  props: {},
  components: {
    ListBar,
    Collapse
  },
  data() {
    return {}
  },
  computed: {},
  mounted: function() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.millennium-kiln {
  .w {
    padding: 50px 0;
  }
  .time-content {
    height: 500px;
    background-color: #fff;
    position: relative;
    > div {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
    }
    &.history {
      background: url('../../../static/images/home/history-bg.jpg') 100% center
        repeat;
    }
    &.famous {
      background: url('../../../static/images/home/famous-bg.jpg') 100% center
        repeat;
    }
    &.documents {
      background: url('../../../static/images/home/documents-bg.jpg') 100%
        center repeat;
    }
  }
}
</style>
